export default __webpack_public_path__ + "static/media/uber.7b5f13c1.png";